export default {
  listaContenidos: [],
  // etapas del plan
  etapaTitle: null,
  etapaPosition: -1,
  etapaTabs: null,
  // submenú
  subMenuPosition: -1,
  subMenuTabs: null,
  // menu inicio
  inicioMenuPosition: -1,
  inicioMenuTabs: null,
  // plan de movilidad
  isLoading: true,
  porcentajeAvance: 0,
  totalPlanesEjecucion: 0,
  estadoEjecucion: 0,
  estadoPlan: 0,
  estadoProceso: 0,
  ultimoEstadoProces: 0,
  idplanMovilidad: null,
  idtokenEncuesta: null,
  habilitarTokenEncuesta: null,
  estadoTokenEncuesta: null,
  estadoEncuestaCentro: null,
  cargaInicial: false,
  medidasGeneradas: false,
  medidasPlanMovilidad: [],
  subMedidasPlanesMovilidad: [],
  tareasPlanesMovilidad: [],
  isMedidasLoading: false,
  isLoadingDocumento: false,
  isSubMedidasLoading: false,
  rutusuario: null,
  nombreusuario: null,
  emailusuario: null,
  planesMovilidad: [],
  fechaCreacion: null,
  // de la encuesta de trabajadores,
  encuestaHombres: null,
  encuestaMujeres: null,
  cantidadHombresCentro: null,
  cantidadMujeresCentro: null,
  fechaCierreEncuestaTrabajador: null,
  // submedidas modal
  isOpenSubMedidaModal: false,
  isLoadingSubMedidaModal: false,
  dataSubMedidaModal: null,
  // encuesta trabajadores modal
  isOpenEncuestaModal: false,
  dataEncuestaModal: null,
  // alerta acción
  alertaCode: "",
  alertaMensaje: null,
  alertaCall: false,
  // accidentes
  listadoSiniestros: null,
  isLoadingSiniestros: false,
  esEncargado: false,
  // empleados
  employees: [],
  isEmployeesLoaded: false,
};
